export default __webpack_public_path__ + "static/media/gallery-wip-pommel_09.218e4f63.jpg";